import { render, staticRenderFns } from "./OlabConstruct.vue?vue&type=template&id=eacfeed4&"
import script from "./OlabConstruct.vue?vue&type=script&lang=js&"
export * from "./OlabConstruct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports